import {
  MANAGER_SET_SELECTED_TEAM,
  MANAGER_SET_TEAM_LIST,
} from "../actions/manager.actions.js";

const initialState = {
  teams: [],
  teamsStatus: null,
  selectedTeam: undefined,
};

export const managerReducer = (state = initialState, action) => {
  switch (action.type) {
    case MANAGER_SET_TEAM_LIST:
      return {
        ...state,
        teams: action.data,
        teamsStatus: action.status,
      };
    case MANAGER_SET_SELECTED_TEAM:
      return {
        ...state,
        selectedTeam: action.data,
      };
    default:
      return state;
  }
};
